module.exports = __webpack_public_path__ + "static/img/about_Jovens_02_zh.c1ee1c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_Jovens_02_zh.png
// module id = vT+7
// module chunks = 34